import React from "react"
import { compose } from "redux"
import { connect } from "react-redux"
import { firestoreConnect } from "react-redux-firebase"

import IndexNavbar from "components/Navbars/IndexNavbar.js"
import MerchantsListCards from "components/User/MerchantsListCards.js"
import Footer from "components/Footers/Footer.js"

class MerchantsList extends React.Component {
  render() {
    return (
      <>
        <div>
          <IndexNavbar />
          <div className="main-content">
            <MerchantsListCards
              zipCode={this.props.zipCode}
              merchants={this.props.merchants}
            />
          </div>
          <Footer />
        </div>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let merchants = [],
    zipCode = ""
  if (
    state &&
    state.firestore &&
    state.firestore.ordered &&
    state.firestore.ordered.fetchedMerchants &&
    state.firestore.ordered.fetchedMerchants.length > 0
  ) {
    merchants = state.firestore.ordered.fetchedMerchants
  }
  if (
    ownProps &&
    ownProps.match &&
    ownProps.match.params &&
    ownProps.match.params.zipCode
  ) {
    zipCode = ownProps.match.params.zipCode
  }
  return {
    merchants,
    zipCode,
  }
}

const mapDispatchToProps = () => {
  return {}
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => {
    return [
      {
        collection: "merchants",
        where: [
          ["zipCode", "array-contains", props.zipCode || ""],
          ["verified", "==", true],
          ["status", "==", "enabled"],
        ],
        storeAs: "fetchedMerchants",
      },
    ]
  })
)(MerchantsList)
